import React, { Component } from 'react';
import Table, { ColumnProps } from 'antd/lib/table';
import umbrella from 'umbrella-storage';
import ContactService, { ContactListRequest, IContactInfo, IContactInfoList } from '../../service/contact/ContactService';
import './page-contact.less';
import { timestamp2localdate } from '../../utils/dateTools';
import { Tooltip } from 'antd';
import { getCompanyUrlParam } from '../../utils';

interface ContactTableProps {
    company: number | null;
    way: number | null;
    customer: number | null;
    beginTime: string | null;
    endTime: string | null;
    sales: number | null;
    isMyContactContext?: boolean;
}

interface ContactTableState {
    pageData: IContactInfoList | null;
    sourceData: IContactInfo[];
    salesSelectValue: number | null;
    beginTimeValue: string | null;
    endTimeValue: string | null;
    pagination: any;
    selectedRowKeys: number[];
}

//获取pageSize
const defaultPageSize = 5;
const getPageSize = () => {
    return umbrella.getLocalStorage('contactPageSize') ? umbrella.getLocalStorage('contactPageSize') : defaultPageSize;
}

export const getContactWay = (way: number) => {
    if (way === 0){
        return 'Out';
    }
    else{
        return 'In';
    }
}

//自定义ContactTable
class ContactTable extends Component<ContactTableProps, ContactTableState> {
    state: ContactTableState = {
        pageData: {
            records: [],
            total: 0,
            size: 0,
            current: 1,
            pages: 0
        },
        sourceData: [],
        beginTimeValue: null,
        endTimeValue: null,
        salesSelectValue: null,
        pagination: {
            current: parseInt(localStorage.getItem('contactCurrentPage') || '1', 10),
            pageSize: getPageSize(),
            total: 0
        },
        selectedRowKeys: [],
    };

    async componentDidMount() {
        await this.getContactTableData(1, this.props.company);
    }

    async componentDidUpdate(prevProps: Readonly<ContactTableProps>, prevState: Readonly<ContactTableState>) {
        if (prevState.pagination && prevState.pagination.pageSize !== this.state.pagination.pageSize) {
            await this.getContactTableData(1);
        }
    }

    //定义表格的列属性
    columns: ColumnProps<any>[] = [
        { title: '销售', width: 15, dataIndex: 'salesName', key: 'salesName' },
        { 
            title: '客户公司', 
            width: 25, 
            dataIndex: 'companyName', 
            key: 'companyName',
            render: (text: string, record: IContactInfo) => (
                <a href={`/#/app/customer/list?company=${record.company}`} rel="noopener noreferrer" target="_blank">
                    {text}
                </a>
            )
        },
        { title: '联络人', width: 15, dataIndex: 'customerName', key: 'customerName'},
        { 
            title: '沟通内容', 
            width: 70, 
            dataIndex: 'content', 
            key: 'content',
            render: (text: string) => (
                <Tooltip 
                    title={<div style={{ whiteSpace: 'pre-wrap', maxWidth: '750px' }}>{text}</div>}
                    placement="topLeft"
                    overlayStyle={{ maxWidth: '750px' }}
                >
                    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: '100px',
                        overflowY: 'auto', cursor: 'pointer'}}
                    >
                        {text}
                    </div>
                </Tooltip>
            )
        },
        { title: '联系时间', width: 15, dataIndex: 'time', key: 'time'},
        { title: '联系方式', width: 15, dataIndex: 'tools', key: 'tools'},
        { title: '呼入/呼出', width: 15, dataIndex: 'way', key: 'way'},           
        { title: '备注', width: 20, dataIndex: 'remark', key: 'remark' },
        {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 12,
            render: (record: IContactInfo) => (
                <>
                    <button onClick={() => this.handleEditBottonClick(record)}>编辑</button>  
                </>
            ),
        },
    ];
    
    // 允许外部组件手动重置分页
    setPaginationPage = (pageNo: number) => {
        this.setState({
            pagination: { ...this.state.pagination, current: pageNo }
        });
    };

    //获取指定页码的查询数据
    getContactTableData = async ( pageNo:number, company?:number | null, way? :number | null, customer?:number | null,
                                 beginTimeValue?:string | null, endTimeValue?: string | null, 
                                 salesSelectValue?: number | null) => {
        const request: ContactListRequest = {
        contactQueryParam: {
            company: company ?? this.props.company ?? undefined,
            way: way ?? this.props.way ?? undefined,
            customer: customer ?? this.props.customer ?? undefined,
            beginTime: beginTimeValue ?? this.props.beginTime ?? undefined,
            endTime: endTimeValue ?? this.props.endTime ?? undefined,
            sales: salesSelectValue ?? this.props.sales ?? undefined,

        },
        pageNo,
        pageSize: this.state.pagination.pageSize,
        };

        try {
            const response = getCompanyUrlParam() ? 
                             await ContactService.getContactInfoByCompanyId(company) :
                             (this.props.isMyContactContext ? 
                                await ContactService.getMyCustomerContactListInfo(request) :
                                await ContactService.getCustomerContactListInfo(request));
            if (response) {
                const pageData: IContactInfoList = response.data && response.data.contactInfoList ? response.data.contactInfoList : [];
                const ContactRecords = pageData && pageData.records ? response.data.contactInfoList.records : [];
                const mappedSourceData: IContactInfo[] = ContactRecords.map((item: any) => ({
                    id: item.id,
                    salesName: item.salesName,
                    customer: item.customer,
                    customerName: item.customerName,
                    companyName: item.companyName,
                    company: item.company,
                    time: timestamp2localdate(item.time,false),
                    tools: item.tools,
                    content: item.content,
                    remark: item.remark,
                    way: getContactWay(item.way)
                }));
                this.setState({
                    pageData: { ...pageData, current: pageNo },
                    sourceData: mappedSourceData,
                    pagination: { ...this.state.pagination, total: pageData.total },
                });
            }
        } catch (error) {
            console.error('获取公司列表失败:', error);
        }
    };

    //页码切换事件
    handleChangePage = (pageNo: number) => {
        if (pageNo !== this.state.pagination.current) {
            localStorage.setItem('contactCurrentPage', pageNo.toString());
            this.setState(
                (prevState) => ({
                    pagination: { ...prevState.pagination, current: pageNo },
                }),
                () => this.getContactTableData(pageNo, this.props.company, this.props.way, this.props.customer, 
                                                this.props.beginTime, this.props.endTime, 
                                                this.props.sales)
            );
        }
    };

    //PageSize选项卡事件
    changePageSize = (current: number, pageSize: number) => {
        umbrella.setLocalStorage('contactPageSize', pageSize);
        this.setState({
            pagination: { current: 1, pageSize, total: this.state.pagination.total }
        });
    };


    //编辑按钮事件
    handleEditBottonClick = (contactData: IContactInfo) => {
        // 跳转公司管理页面
        const queryString = `?id=${contactData.id}`; 
        window.location.href = '/#/app/customer/contact/manager' + queryString;
    }

    // 添加选择改变的处理函数
    onSelectChange = (selectedRowKeys: number[]) => {
        this.setState({ selectedRowKeys });
    };

    render() {
        const { sourceData, pagination } = this.state;
        const dataWithKeys = sourceData.map((row) => ({ ...row, key: row.id }));
        const columnsToShow = this.props.company ? this.columns.filter(col => col.key !== 'companyName') : this.columns; //在客户沟通记录页面隐藏公司名称

        return (
            <div style={{ width: '100%', overflow: 'auto' }}>
                <Table size="small"
                    columns={columnsToShow}
                    dataSource={dataWithKeys}
                    pagination={{
                        showSizeChanger: true,
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        pageSizeOptions: ['5', '10', '20', '50', '100'],
                        showTotal: (total, range) => `显示第 ${range[0]} 到第 ${range[1]} 条记录，共 ${total} 条记录`,
                        onShowSizeChange: this.changePageSize,
                        onChange: this.handleChangePage,
                    }}
                    scroll={{ x: 1580, y: 360 }}
                />
            </div>
        );
    }

};

export default ContactTable;

